'use client';

import { useState } from "react";
import axios from "axios";

const SLACK_HOOK_URL = process.env.NEXT_PUBLIC_SLACK_GENERAL

const useSlack = (webhookUrl = SLACK_HOOK_URL) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendMessage = async (object) => {
    let result = "";

    for (let i in object) {
      result += `${i}: ${object[i]} \n`
    }

    const payload = { "text": result }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      if (response.status === 200) {
        console.log('Message sent to Slack');
      } else {
        setError('Error sending message to Slack');
        console.error('Error sending message to Slack');
      }
    } catch (error) {
      setError('Error sending message to Slack');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return { sendMessage, loading, error };
};

export default useSlack;